// extracted by mini-css-extract-plugin
module.exports = {"voiting":"VotingPopup_voiting__2PAlO","header":"VotingPopup_header__AmpN3","text":"VotingPopup_text__2CECq","user":"VotingPopup_user__3wTWZ"};